module.exports = __webpack_public_path__ + "static/media/logo@2x.0ceefab1.png";